/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { inAdminView, inOperatorView, inSuperAdminView } from 'utils/role';
import AutoCard from 'components/AutoCard';
import styles, { overrideCard } from './styles';

interface Props {
  title: string;
  value: string;
  subtitle: string;
  subtitleValue: string;
  companySelected: CompanyData | null;
  role?: RolesEnum;
}

const EnvironmentInstancesCard = ({
  title,
  value,
  subtitle,
  subtitleValue,
  companySelected,
  role,
}: Props) => {
  const classes = makeStyles(styles())();
  const { breakpoints } = useTheme();

  return (
    <Grid item className={classes.containerCard}>
      <AutoCard overrideClasses={overrideCard(breakpoints)}>
        <Grid>
          <Grid item className={classes.item}>
            <Typography className={classes.titleCard}>{title}</Typography>
            <Typography
              className={clsx(classes.valueCard, {
                [classes.valueCardGreen]: inAdminView(role, companySelected),
                [classes.valueCardGray]: inSuperAdminView(
                  role,
                  companySelected
                ),
                [classes.valueCardBlue]: inOperatorView(role, companySelected),
                [classes.valueCardYellow]: companySelected,
              })}
            >
              {value}
            </Typography>
            {subtitle && (
              <Grid container className={classes.subtitleGrid}>
                <Typography className={classes.cardSubtitleText}>
                  {subtitle}
                  {':'}
                </Typography>
                <Typography className={classes.cardSubtitleValue}>
                  {subtitleValue}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </AutoCard>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(EnvironmentInstancesCard);
